export default __webpack_public_path__ + "static/media/logo-region-normandie-noir.53de4c79.svg";